import confirmService from '../services/confirmService';

export default {
  data () {
    return {
      justOpened: false,
      confirmPromise: null,
      confirmPromiseResolve: null,
    };
  },
  computed: {
    confirmModalClosed () {
      return confirmService.closed;
    },
    confirmModalAccepted () {
      return confirmService.accepted;
    },
  },
  methods: {
    confirm (question, okLabel = 'Ok', cancelLabel = 'Cancel') {
      this.confirmPromise = new Promise(resolve => {
        this.confirmPromiseResolve = resolve;
        this.justOpened = true;
        confirmService.open(question, okLabel, cancelLabel);
      });

      return this.confirmPromise;
    },
    resetConfirm () {
      confirmService.close();
      this.confirmPromise = null;
      this.confirmPromiseResolve = null;
    },
  },
  watch: {
    confirmModalClosed () {
      if (this.justOpened) {
        this.justOpened = false;

        return;
      }

      if (!this.confirmPromiseResolve) {
        return;
      }

      this.confirmPromiseResolve(this.confirmModalAccepted);
      this.resetConfirm();
    },
  },
  mounted () {
    confirmService.close();
  },
  destroyed () {
    confirmService.close();
  },
};
